import BatteryUses from './BatteryUses';

export default BatteryUses;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/ESSPoints/BatteryUses/index.js